import { Model } from '@/models/Model';
export class StudentDocumentStatus extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'StudentDocumentStatus';
        this.$endpoint = '/student-document-statuses';
        this.$fillable = [];
    }
}
